<body>
  <div id="fullpage">
    <div id="bg" class="triangle"></div>
    <div class="light">
      <img
        src="{{ onPassiveBaseUrl }}onpassive-(nov12)/images/light.png"
        alt="image"
      />
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-4">
          <div class="logo">
            <img
              src="{{ onPassiveBaseUrl }}onpassive-(nov12)/images/logo.png"
              alt="logo"
            />
          </div>
        </div>
      </div>
      <div class="row justify-content-between align-items-center">
        <div class="col-lg-4">
          <div class="left_first_box">
            <p>
              The only thing missing in your life is the spotlight on all the
              hard work and determination you are contributing to your dreams.
              If you feel the same way, we at ONPASSIVE curates the best
              internet marketing opportunities for millions across the world to
              shine from within. We believe those who shine within themselves
              can guide others too. Join our purpose in illuminating the whole
              world.
            </p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="video_box acc_panel anim_in">
            <video
              id="my-video"
              class="video-js video-size w-100 h-auto"
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
        <div class="col-lg-4 main_top">
          <h1 class="title-slide-in">
            <span class="one">NEW</span>
            <span class="two">REVOLUTIONIZED</span>
            <span class="three">INTERNET</span>
            <span class="four">MARKETING</span>
            <span class="five shine">SOLUTIONS</span>
          </h1>
          <div class="btn-block">
            <a
              href="/registration/user?reg={{ userId }}"
              name="regform"
              target="_blank"
              rel="noopener"
              class="animated-button1"
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              Become a Founder Now
            </a>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="right_box">
            <div class="bubbles">
              <h1 class="ml3">LAUNCHING SOON!</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
